import { Fragment, h } from "preact";
import { useEffect } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";

import AppLayout from "../components/AppLayout.jsx";
import Button from "../components/Button.jsx";
import DocumentPreviewItem from "../components/DocumentPreviewItem.jsx";
import i18n from "../i18n.js";
import { fetchAll, setLoading, setPageTitle } from "../store";

export default function DocumentsPage(props) {
  const taskFiles = useSelector((state) => state.documents.taskFiles);
  const userFiles = useSelector((state) => state.documents.userFiles);
  const dispatch = useDispatch();

  useEffect(async () => {
    dispatch(setLoading(true));
    await dispatch(fetchAll());
    dispatch(setLoading(false));
  }, []);

  const files = [...taskFiles, ...userFiles];

  if (files.length === 0) {
    return (
      <AppLayout title={i18n.t("pages.titles.docs")}>
        <div class="center">
          <img src="/images/documents_empty_state.svg" class="page-illu" />
        </div>

        <div class="row">
          <div class="col s12 l6 offset-l3 center">
            <h1 class="t-h6 t-h8--margin">
              {i18n.t("pages.documents.empty_state.title")}
            </h1>
            <p class="t-body3 mb-48">
              {i18n.t("pages.documents.empty_state.description")}
            </p>

            <Button to="/tasks" secondary>
              {i18n.t("pages.documents.empty_state.action")}
            </Button>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout title={i18n.t("pages.titles.docs")}>
      <div class="row">
        {files.map((document) => (
          <div class="col s12 l4">
            <DocumentPreviewItem document={document} />
          </div>
        ))}
      </div>
    </AppLayout>
  );
}
